import { cn } from "@humanex/ui/libs";

interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: string;
  className?: string;
}

export function Box({ children, className, padding = "p-4 md:p-6", ...props }: BoxProps) {
  return (
    <div
      className={cn(
        "bg-white rounded-2xl border border-gray-200 transition-all duration-300",
        padding,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
